module.exports = "/legacy/c712a3c732e958b7f01e260b3dd3fbb9.svg";